module.exports = __webpack_public_path__ + "static/media/icon-products.c0b8e658.svg";